import React, { useState, createContext } from "react";

import { ConfigProvider } from "antd";
import vi from "antd/locale/vi_VN";
import { Toaster } from "sonner";

import { useElementSize } from "@custom-react-hooks/use-element-size";

import { Header } from "./components/header/Header";
import { Profile } from "./components/profile/Profile";
import { Camera } from "./components/camera/Camera";
import { Login } from "./components/login/Login";
import { useEffect } from "react";
import { startTransition } from "react";
import axios from "axios";

export const AppContext = createContext();

function App() {
  const [setting, setSetting] = useState(() => {
    const setting = localStorage.getItem("setting");

    return setting
      ? {
          api: JSON.parse(setting).api,
          confidence: +import.meta.env.VITE_CONFIDENCE_THRESHOLD,
          quality: +import.meta.env.VITE_QUANTITY,
        }
      : {
          confidence: +import.meta.env.VITE_CONFIDENCE_THRESHOLD,
          quality: +import.meta.env.VITE_QUANTITY,
        };
  });

  const [isRefreshStreaming, setIsRefreshStreaming] = useState(false);

  const [customers, setCustomers] = useState([]);

  const [accessToken, setAccessToken] = useState(
    localStorage.getItem("accessToken")
  );

  const [setRef, size] = useElementSize();

  useEffect(() => {
    if (accessToken && !setting.streaming) {
      startTransition(async () => {
        const responseSetting = await axios.get(
          `${import.meta.env.VITE_API_BOOKING}/api/setting/camera`
        );

        if (responseSetting.data) {
          if (!setting?.api) {
            localStorage.setItem(
              "setting",
              JSON.stringify({
                api: responseSetting.data.cameraApi,
              })
            );
          }
          setSetting((state) => ({
            ...state,
            api: state?.api ?? responseSetting.data.cameraApi,
            streaming: responseSetting.data.cameraStreaming,
          }));
        }
      });
    }
  }, [accessToken]);

  return (
    <ConfigProvider
      locale={vi}
      theme={{
        cssVar: true,
        token: {
          colorPrimary: "#000",
          controlHeight: 36,
          fontFamily: "Poppins",
        },
        components: {
          Form: {
            itemMarginBottom: 16,
          },
        },
      }}
    >
      <AppContext.Provider
        value={{
          setting,
          setSetting,
          customers,
          setCustomers,
          accessToken,
          setAccessToken,
          layoutRightSize: size,
          isRefreshStreaming,
          setIsRefreshStreaming,
        }}
      >
        <Login>
          <div className="layout">
            <Header />
            <div className="layout-content">
              <div className="layout-left" ref={setRef}>
                <Camera />
              </div>
              <div className="layout-right">
                <Profile />
              </div>
            </div>
          </div>
        </Login>
        <Toaster richColors />
      </AppContext.Provider>
    </ConfigProvider>
  );
}

export default App;
